import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export const EMAIL_REGEX = new RegExp(
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);

export function isEmailValid(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

export function positiveNumbers(event: KeyboardEvent): boolean {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

export const passwordStrengthValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value;
  if (!value) return null;

  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSymbol = /[!@#$%^&*(),.?":{}|<>/_\-=+\[\];'~]/.test(value);
  const hasMinLength = value.length >= 8;

  const passwordValid =
    hasUpperCase && hasLowerCase && hasNumber && hasSymbol && hasMinLength;

  return !passwordValid ? { passwordStrength: true } : null;
};
